import { restClient } from '../../client';


export enum UploadedProviderDocumentType {
  stateExhibit = 'state_exhibit',
  certificateOfInsurance = 'certificate_of_insurance',
  licenseOrCertification = 'license_or_certification',
  collaborativeAgreementRenewalAttestation = 'collaborative_agreement_renewal_attestation',
  boardApproval = 'board_approval',
  signedProviderContract = 'signed_provider_contract',
  other = 'other',
}

export const uploadedProviderDocumentTypeLabels: Record<UploadedProviderDocumentType, string> = {
  [UploadedProviderDocumentType.stateExhibit]: 'State Exhibit',
  [UploadedProviderDocumentType.certificateOfInsurance]: 'Certificate of Insurance',
  [UploadedProviderDocumentType.licenseOrCertification]: 'License or Certification',
  [UploadedProviderDocumentType.collaborativeAgreementRenewalAttestation]: 'Collaborative Agreement Renewal Attestation',
  [UploadedProviderDocumentType.boardApproval]: 'Board Approval',
  [UploadedProviderDocumentType.signedProviderContract]: 'Signed Provider Contract',
  [UploadedProviderDocumentType.other]: 'Other',
};

export type UploadedProviderDocument = {
  id: string;
  providerId: string;
  fileUploadId: string;
  documentType: UploadedProviderDocumentType;
  description: string | null;
  createdAt: string;
  updatedAt: string;
  archivedAt: string | null;
  archivedBy: string | null;
};

export const createProviderDocument = (data: {
  file_upload_id: string;
  document_type: string;
  description: string;
}) => restClient.request<{ data: UploadedProviderDocument }>(`/api/v1/provider/documents`, {
  method: 'POST',
  data,
});

export const updateUploadedProviderDocument = (
  documentId: string,
  data: { document_type: UploadedProviderDocumentType; description: string }
) => restClient.request<{ data: UploadedProviderDocument }>(
  `/api/v1/provider/documents/${documentId}`,
  { method: 'PATCH', data }
);

export const deleteUploadedProviderDocument = (
  documentId: string,
  data: { reason_for_delete: string }
) => restClient.request<{ data: null }>(
  `/api/v1/provider/documents/${documentId}/delete`,
  { method: 'POST', data }
);

export const getProviderDocumentDownloadLink = (documentId: string) =>
  restClient.request<{ data: { downloadLink: string } }>(
    `/api/v1/provider/documents/${documentId}/download_link`,
    { method: 'POST' }
  );
